import { z } from 'zod';
import { emailSignatureLicenseSchema } from './license.js';
/**
 * Employee record returned by `GET /employee` — a passthrough of the SuiteCRM
 * custom API `GET /Api/V8/custom/Employee/{id}`.  Normalisation (phone
 * formatting, office resolution, license assembly, empty-string fallbacks)
 * is owned by the CRM custom API; the web app applies presentation-only
 * transforms (date formatting, signature/card customisations).
 */
export const employeeSchema = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string(),
    title: z.string(),
    // Formatted phone variants (always present; empty string when not on record)
    phone: z.string(),
    phoneWork: z.string(),
    phoneMobile: z.string(),
    phoneOther: z.string(),
    phoneOffice: z.string(),
    // Resolved office address
    street: z.string(),
    city: z.string(),
    state: z.string(),
    zip: z.string(),
    // Office review / social links
    zillow: z.string(),
    zillowPm: z.string(),
    yelp: z.string(),
    // Optional profile enrichments
    linkedIn: z.string().optional(),
    agentPage: z.string().optional(),
    headshot_image_url: z.string().optional(),
    // CRM metadata preserved for downstream logic
    office_c: z.string().optional(),
    department: z.string().optional(),
    employee_type_c: z.string().optional(),
    // License fields
    license: z.array(emailSignatureLicenseSchema),
    lending_license_tx_c: z.string().optional(),
    real_estate_license_tx_c: z.string().optional(),
});
